import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const MapContainer = styled.section`
  min-height: 80vh;
  padding: 5rem 2rem;
  background: linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%);
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled(motion.h2)`
  font-size: clamp(2.5rem, 5vw, 4rem);
  text-align: center;
  margin-bottom: 3rem;
  background: linear-gradient(135deg, #3b82f6, #06b6d4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
`;

const MapGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const LocationCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 1.5rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;
`;

const LocationIcon = styled.div`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const LocationName = styled.h3`
  color: #3b82f6;
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

const LocationStats = styled.div`
  color: #94a3b8;
  font-size: 0.9rem;
`;

function GlobalMap() {
  const locations = [
    { name: 'Mumbai', icon: '🏗️', projects: '15+ Projects', savings: '₹12 Crores' },
    { name: 'Delhi', icon: '🚇', projects: '8 Metro Lines', savings: '40% Faster' },
    { name: 'Bangalore', icon: '🏢', projects: '12 IT Parks', savings: 'LEED Certified' },
    { name: 'Chennai', icon: '🚢', projects: '3 Ports', savings: '100yr Design' },
    { name: 'Ahmedabad', icon: '🌉', projects: '5 Bridges', savings: '75% Stronger' }
  ];

  return (
    <MapContainer id="global-map" data-section="global-map">
      <Content>
        <SectionTitle
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Project Locations
        </SectionTitle>
        
        <motion.div
          style={{
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '20px',
            padding: '2rem',
            textAlign: 'center',
            marginBottom: '2rem'
          }}
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <h3 style={{ color: '#3b82f6', marginBottom: '1rem' }}>🇮🇳 India Coverage</h3>
          <p style={{ color: '#94a3b8' }}>
            Our rebar couplers have been successfully deployed across major Indian cities, 
            from high-rise residential complexes to critical infrastructure projects.
          </p>
        </motion.div>

        <MapGrid>
          {locations.map((location, index) => (
            <LocationCard
              key={location.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <LocationIcon>{location.icon}</LocationIcon>
              <LocationName>{location.name}</LocationName>
              <LocationStats>
                <div>{location.projects}</div>
                <div style={{ color: '#10b981', fontWeight: '600' }}>{location.savings}</div>
              </LocationStats>
            </LocationCard>
          ))}
        </MapGrid>
      </Content>
    </MapContainer>
  );
}

export default GlobalMap;